const webInfo = {
    'x-os-version': 'web',
    'x-package-name': 'carta-web',
    'x-package-version': '1.0',
    'x-model-name': 'browser',
    'x-started': Date.now() / 1000,
    'x-requested': Date.now() / 1000,
    'x-app-id': 'web',
}

/* istanbul ignore next */
const androidInfo = (modelName, osVersion, packageName, packageVersion, cartaVersion, appKey, started) => {
    return {
      'x-os-version': osVersion || 'unknown',
      'x-package-name': packageName || 'unknown',
      'x-package-version': packageVersion || 'unknown',
      'x-model-name': modelName || 'unknown',
      'x-started': started || 'unknown',
      'x-requested': Date.now() / 1000,
      'x-app-id': appKey || 'unknown',
      'x-carta-version': cartaVersion || 'unknown',
    };
};

export {
    webInfo,
    androidInfo
}